



















































































import { defineComponent, computed } from "@vue/composition-api";
import eventBus from "@monorepo/utils/src/eventBus";
import { environmentVariables } from "@monorepo/utils/src/variables/environmentVariables";
import { MODAL_EVENT_BUS_ACTIONS } from "@monorepo/utils/src/eventBus/events/modal";
import TableFileList from "./TableFileList.vue";
import useTableCells from "@monorepo/utils/src/composables/useTableCells";
import moment from "moment";
import CardModalInfoElement from "@monorepo/uikit/src/components/tableCardModal/CardModalInfoElement.vue";
import { commissionMemberListFields } from "@monorepo/expertReviewCommission/src/views/ERCProtocolsView/constants/commissionMemberListFields";

export enum ApproveStatuses {
  APPROVED = "APPROVED",
  ON_APPROVING = "IN_PROGRESS",
}

export default defineComponent({
  name: "ApproveTable",
  components: {
    TableFileList,
    CardModalInfoElement,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    isHideEditButtons: {
      type: Boolean,
    },
    isMainPerson: {
      type: Boolean,
    },
    tableHeaders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ApproveStatuses,
      commissionMemberListFields,
      successIcon: `${environmentVariables.BASE_URL}assets/images/tk-journal/successIcon.svg`,
      errorIcon: `${environmentVariables.BASE_URL}assets/images/tk-journal/errorIcon.svg`,
      pendingIcon: `${environmentVariables.BASE_URL}assets/images/tk-journal/pendingIcon.svg`,
    };
  },
  computed: {
    resultData(): Record<string, any>[] {
      return this.items as Record<string, string>[];
    },
    statusIcon() {
      return (status: string) => {
        switch (status) {
          case ApproveStatuses.APPROVED:
            return this.successIcon;
          case ApproveStatuses.ON_APPROVING:
            return this.pendingIcon;
          default:
            return this.errorIcon;
        }
      };
    },
    signDate() {
      return (date?: string) => {
        return date ? moment(date).format("YYYY-MM-DD HH:mm") : "";
      };
    },
  },
  methods: {
    onScrollCb(e: Event) {
      const element = document.getElementById("doc-table");
      if (element) {
        element.scrollLeft = (e.target as HTMLElement)?.scrollLeft;
      }
    },
  },
  mounted() {
    (this as unknown as { getTableWidth: () => void }).getTableWidth();
  },
  beforeMount() {
    eventBus.$on(MODAL_EVENT_BUS_ACTIONS.TOGGLE_VIEW_MODE, this.getTableWidth as () => void);
  },
  beforeDestroy() {
    eventBus.$off(MODAL_EVENT_BUS_ACTIONS.TOGGLE_VIEW_MODE, this.getTableWidth as () => void);
  },
  setup(props, { root }) {
    const tableHeaders = computed(() => props.tableHeaders);
    const { headers, getTableWidth } = useTableCells(root, "", tableHeaders, 1120, true);
    return {
      headers,
      getTableWidth,
    };
  },
});
